export default __webpack_public_path__ + "static/media/Mask_Group_2.4bd04319.png";